import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "../css/home.css";
import { getNewCmsAction } from "../../../Action/user.action";

const NftBoxTermsAndCondition = () => {
  const [termsandconditionlist, settermsandconditionlist] = useState({
    nftboxterms: ""
  });

  useEffect(() => {
    getTermsAndConditionFunc();
  }, []);

  const getTermsAndConditionFunc = async () => {
    let res = await getNewCmsAction("nftBox-tc");
    if (res.success && res.data?.cms_value) {
      settermsandconditionlist({ nftboxterms: res.data.cms_value });
    } else {
      console.error("Failed to fetch CMS content");
    }
  };

  return (
    <div className="lighttheme overflow-hidden hero" style={{ minHeight: "100vh" }}>
      <section className="herobanner position-relative text-white overflow-hidden" style={{ backgroundColor: "black" }}>
        <Container>
          <Row className="align-items-center">
            <div
              className="jovitClass"
              dangerouslySetInnerHTML={{ __html: termsandconditionlist.nftboxterms }}
            />
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default NftBoxTermsAndCondition;
